// Mock location data for Philippine addresses
// This will be replaced with real data integration later

export const mockBarangays = [
  // Metro Manila Barangays
  'Barangay 1',
  'Barangay 2', 
  'Barangay 3',
  'Poblacion',
  'San Antonio',
  'Santa Cruz',
  'San Jose',
  'San Miguel',
  'Santo Niño',
  'Bagong Silang',
  'Bagong Pag-asa',
  'Tondo I/II',
  'Malate',
  'Ermita',
  'Binondo',
  'Quiapo',
  'Sampaloc',
  'Santa Mesa',
  'Paco',
  'San Nicolas',
  'Intramuros',
  'Port Area',
  'Pandacan',
  'Santa Ana (Manila)',
  'San Andres',
  'Singalong',
  'Baclaran',
  'Don Bosco',
  'La Huerta',
  'Moonwalk',
  'Talon Uno',
  'Talon Dos',
  'Talon Tres',
  'Talon Cuatro',
  'Talon Cinco',
  'Almanza Uno',
  'Almanza Dos',
  'Daniel Fajardo',
  'Elias Aldana',
  'Ilaya',
  'Manuyo Uno',
  'Manuyo Dos',
  'Pilar',
  'Pulang Lupa Uno',
  'Pulang Lupa Dos',
  'Zapote',
  'Pio del Pilar',
  'Poblacion (Makati)',
  'San Isidro',
  'San Roque',
  'Ugong',
  'Western Bicutan',
  'Central Bicutan',
  'Eastern Bicutan',
  'Fort Bonifacio',
  'Hagonoy',
  'Ibayo-Tipas',
  'Ligid-Tipas',
  'Lower Bicutan',
  'New Lower Bicutan',
  'Napindan',
  'Palingon',
  'Santa Ana (Taguig)',
  'Signal Village',
  'Tuktukan',
  'Ususan',
  'Wawa'
];

export const mockCities = [
  // Metro Manila Cities
  'Manila',
  'Quezon City',
  'Makati',
  'Taguig',
  'Pasig',
  'Mandaluyong',
  'San Juan',
  'Marikina',
  'Caloocan',
  'Las Piñas',
  'Muntinlupa',
  'Parañaque',
  'Pasay',
  'Valenzuela',
  'Malabon',
  'Navotas',
  'Pateros',
  
  // Cavite Cities
  'Cavite City',
  'Bacoor',
  'Imus',
  'Dasmariñas',
  'General Trias',
  'Trece Martires',
  'Tagaytay',
  
  // Laguna Cities
  'Santa Rosa',
  'Biñan',
  'San Pedro',
  'Cabuyao',
  'Calamba',
  'Los Baños',
  'San Pablo',
  
  // Rizal Cities
  'Antipolo',
  'Cainta',
  'Taytay',
  'Angono',
  'Binangonan',
  'Rodriguez (Montalban)',
  'San Mateo',
  'Marikina (Rizal)',
  
  // Bulacan Cities
  'Malolos',
  'Meycauayan',
  'San Jose del Monte',
  'Marilao',
  'Bocaue',
  'Balagtas',
  'Guiguinto',
  'Pandi',
  
  // Major Cities Outside Metro Manila
  'Cebu City',
  'Davao City',
  'Zamboanga City',
  'Cagayan de Oro',
  'General Santos',
  'Butuan',
  'Iligan',
  'Cotabato City',
  'Koronadal',
  'Tacloban',
  'Legazpi',
  'Naga',
  'Iloilo City',
  'Bacolod',
  'Dumaguete',
  'Baguio',
  'Dagupan',
  'San Fernando (La Union)',
  'San Fernando (Pampanga)',
  'Angeles',
  'Olongapo',
  'Batangas City',
  'Lipa',
  'Tanauan',
  'Lucena',
  'Puerto Princesa'
];

export const mockProvinces = [
  // Luzon
  'Metro Manila',
  'Abra',
  'Albay',
  'Apayao',
  'Aurora',
  'Bataan',
  'Batanes',
  'Batangas',
  'Benguet',
  'Bulacan',
  'Cagayan',
  'Camarines Norte',
  'Camarines Sur',
  'Catanduanes',
  'Cavite',
  'Ifugao',
  'Ilocos Norte',
  'Ilocos Sur',
  'Isabela',
  'Kalinga',
  'La Union',
  'Laguna',
  'Marinduque',
  'Masbate',
  'Mountain Province',
  'Nueva Ecija',
  'Nueva Vizcaya',
  'Occidental Mindoro',
  'Oriental Mindoro',
  'Palawan',
  'Pampanga',
  'Pangasinan',
  'Quezon',
  'Quirino',
  'Rizal',
  'Romblon',
  'Sorsogon',
  'Tarlac',
  'Zambales',
  
  // Visayas
  'Aklan',
  'Antique',
  'Bohol',
  'Capiz',
  'Cebu',
  'Eastern Samar',
  'Guimaras',
  'Iloilo',
  'Leyte',
  'Negros Occidental',
  'Negros Oriental',
  'Northern Samar',
  'Samar',
  'Siquijor',
  'Southern Leyte',
  
  // Mindanao
  'Agusan del Norte',
  'Agusan del Sur',
  'Basilan',
  'Bukidnon',
  'Camiguin',
  'Compostela Valley',
  'Cotabato',
  'Davao del Norte',
  'Davao del Sur',
  'Davao Occidental',
  'Davao Oriental',
  'Dinagat Islands',
  'Lanao del Norte',
  'Lanao del Sur',
  'Maguindanao',
  'Misamis Occidental',
  'Misamis Oriental',
  'North Cotabato',
  'Sarangani',
  'South Cotabato',
  'Sultan Kudarat',
  'Sulu',
  'Surigao del Norte',
  'Surigao del Sur',
  'Tawi-Tawi',
  'Zamboanga del Norte',
  'Zamboanga del Sur',
  'Zamboanga Sibugay'
];

export const mockCountries = [
  'Philippines',
  'United States',
  'Canada',
  'Australia',
  'United Kingdom',
  'Japan',
  'South Korea',
  'Singapore',
  'Malaysia',
  'Thailand',
  'Indonesia',
  'Vietnam',
  'China',
  'Hong Kong',
  'Taiwan',
  'India',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'New Zealand',
  'Brazil',
  'Argentina',
  'Chile',
  'Mexico',
  'Colombia',
  'Peru',
  'Ecuador',
  'Venezuela',
  'Uruguay',
  'Paraguay',
  'Bolivia',
  'South Africa',
  'Egypt',
  'Morocco',
  'Kenya',
  'Nigeria',
  'Ghana',
  'Ethiopia',
  'Tanzania',
  'Uganda',
  'Rwanda',
  'Botswana',
  'Israel',
  'Turkey',
  'Greece',
  'Portugal',
  'Czech Republic',
  'Poland',
  'Hungary',
  'Slovakia',
  'Slovenia',
  'Croatia',
  'Serbia',
  'Bulgaria',
  'Romania',
  'Lithuania',
  'Latvia',
  'Estonia',
  'Iceland',
  'Ireland',
  'Luxembourg',
  'Malta',
  'Cyprus',
  'Russia',
  'Ukraine',
  'Belarus',
  'Kazakhstan',
  'Uzbekistan',
  'Kyrgyzstan',
  'Tajikistan',
  'Turkmenistan',
  'Georgia',
  'Armenia',
  'Azerbaijan',
  'Mongolia',
  'North Korea',
  'Myanmar',
  'Cambodia',
  'Laos',
  'Bangladesh',
  'Pakistan',
  'Afghanistan',
  'Iran',
  'Iraq',
  'Syria',
  'Jordan',
  'Lebanon',
  'Saudi Arabia',
  'United Arab Emirates',
  'Qatar',
  'Kuwait',
  'Bahrain',
  'Oman',
  'Yemen'
];

// Helper function to get default country
export const getDefaultCountry = (): string => 'Philippines';

// Helper function to validate Philippine postal codes
export const isValidPhilippineZipCode = (zipCode: string): boolean => {
  // Philippine postal codes are 4 digits
  const zipRegex = /^\d{4}$/;
  return zipRegex.test(zipCode);
};

// Helper function to format address for display
export const formatAddress = (addressData: {
  houseUnitNo: string;
  streetName: string;
  subdivisionVillage: string;
  barangay: string;
  city: string;
  province: string;
  zipCode: string;
  country: string;
}): string => {
  const parts = [];
  
  if (addressData.houseUnitNo || addressData.streetName) {
    const addressLine = [addressData.houseUnitNo, addressData.streetName].filter(Boolean).join(' ');
    parts.push(addressLine);
  }
  
  if (addressData.subdivisionVillage) {
    parts.push(addressData.subdivisionVillage);
  }
  
  if (addressData.barangay) {
    parts.push(`Brgy. ${addressData.barangay}`);
  }
  
  if (addressData.city) {
    parts.push(addressData.city);
  }
  
  if (addressData.province && addressData.province !== addressData.city) {
    parts.push(addressData.province);
  }
  
  if (addressData.zipCode) {
    parts.push(addressData.zipCode);
  }
  
  if (addressData.country && addressData.country !== 'Philippines') {
    parts.push(addressData.country);
  }
  
  return parts.join(', ');
};